import { render } from "./GdprSearchSettings.vue?vue&type=template&id=9812fa36"
import script from "./GdprSearchSettings.vue?vue&type=script&lang=js"
export * from "./GdprSearchSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__